import { arrayRemove, arrayUnion } from 'firebase/firestore';
import React from 'react'
import { UITrack, updateTrack } from '../../firebase/firestore'
import { FirestoreTrack } from '../../hooks/useUpload';
import Tag from './Tag'

export type TrackTagsProps = {
    uiTrack: FirestoreTrack;
    editable?: boolean;
    className?: string;

}
export default function TrackTags({ uiTrack, editable, className, ...rest }: TrackTagsProps) {

    const addTag = (newTag: string) => uiTrack?.ref?.path && updateTrack(uiTrack.ref.path, { tags: arrayUnion(newTag) })
    const removeTag = (oldTag: string) => uiTrack?.ref?.path && updateTrack(uiTrack?.ref?.path, { tags: arrayRemove(oldTag) })

    const hasNoTags = !uiTrack.track?.tags?.length
    return (
        <div className={className + ` flex items-center justify-end flex-row-reverse `} {...rest}>

            {uiTrack.track?.tags && uiTrack.track?.tags.map(tag => <Tag editable={editable} value={tag} onRemove={() => removeTag(tag)} />)}
            {!(uiTrack.track?.tags?.length >= 3) && editable && <Tag className={` transition-opacity group-hover:opacity-100 ${'opacity-0'}`} editable={editable} adding otherTags={uiTrack.track?.tags} onAdd={addTag} />}
        </div>
    )
}
